import axios from "axios";

export default function ProjecttypeShowService(typeId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/project_type/" + typeId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
